import { ReactElement } from 'react';

/**
 * Header component for onboarding pages.
 * @returns - React component for AuthHeader.
 */
export default function AuthHeader(): ReactElement {
  return (
    <div className="bg-white dark:bg-background-700 border-b-2 border-background-600">
      <div className="container mx-auto py-4 px-8">
        <img src="/assets/telosair_white.png" alt="Telos Air LOGO" className="h-9" />
      </div>
    </div>
  );
}
